import { ProjectDto } from '@trucktrax/trucktrax-ts-common';
import { QUEUE_RECENT_PROJECT } from '../../constants/actionConstants';

export const queueRecentProject = (currentProject?: ProjectDto) => ({
  type: QUEUE_RECENT_PROJECT,
  payload: currentProject,
});
